import React, { useContext, useEffect, useState } from 'react';
import { API, graphqlOperation, Auth } from "aws-amplify";
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  Filler
} from 'chart.js';
import { Pie, Bar, Line, Scatter, Radar, Doughnut } from 'react-chartjs-2';
import { SpotContext } from '../../context/SpotContext';
import { getSpotResume, listCandidateProfiles, listInterviewEvaluations, listSpotCandidateStatuses } from '../../graphql/queries';

// Register all ChartJS components
ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  Filler
);

const JDSpecificDashboard = () => {
  const { selectedjdid, selectedjdname } = useContext(SpotContext);
  const [isLoading, setIsLoading] = useState(true);
  const [spotResumeData, setSpotResumeData] = useState({});
  const [spotCandidateStatuses, setSpotCandidateStatuses] = useState([]);
  const [appliedCandidates, setAppliedCandidates] = useState([]);
  const [interviewDoneCandidates, setInterviewDoneCandidates] = useState([]);

  // Simulate loading data
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);


  // Spot Data code start

  const {
    gptActivatedFor
  } = useContext(SpotContext);

  console.log(gptActivatedFor, "gptActivatedFor")


  useEffect(() => {
    (async () => {
      console.log(gptActivatedFor, "gptActivatedFor");

      // STEP 1: Parse gptActivatedFor data
      const filterCandidateData = gptActivatedFor?.filterCandidate
        ? JSON.parse(gptActivatedFor.filterCandidate)
        : [];

      const selectedCandidateData = gptActivatedFor?.selectedCandidate
        ? JSON.parse(gptActivatedFor.selectedCandidate)
        : [];

      const filterCandidateEmails = filterCandidateData.map(c => c.email);
      const selectedCandidateEmails = selectedCandidateData.map(c => c.email);

      console.log("Emails from filterCandidate:", filterCandidateEmails);
      console.log("Emails from selectedCandidate:", selectedCandidateEmails);

      // STEP 2: Fetch resume data
      const fetchResumeData = async (id) => {
        if (!id) {
          console.error('No spotResumeID provided');
          return {};
        }

        try {
          const response = await API.graphql(
            graphqlOperation(getSpotResume, { id })
          );
          console.log("aaaaaaaaa", response.data.getSpotResume);
          return response.data.getSpotResume || {};
        } catch (error) {
          console.error("Error fetching Spot Resume:", error);
          return {};
        }
      };

      const spotResume = await fetchResumeData(gptActivatedFor.spotResumeID);
      setSpotResumeData(spotResume);

      const filterResumeCandidateData = spotResume?.filterCandidate
        ? JSON.parse(spotResume.filterCandidate)
        : [];

      const selectedResumeCandidateData = spotResume?.selectedCandidate
        ? JSON.parse(spotResume.selectedCandidate)
        : [];

      const filterResumeCandidateEmails = filterResumeCandidateData.map(c => c.email);
      const selectedResumeCandidateEmails = selectedResumeCandidateData.map(c => c.email);

      const appliedEmails = Array.from(new Set([...filterCandidateEmails, ...filterResumeCandidateEmails]));
      const selectedEmails = Array.from(new Set([...selectedCandidateEmails, ...selectedResumeCandidateEmails]));

      console.log("Applied Emails (merged):", appliedEmails);
      console.log("Selected Emails (merged):", selectedEmails);
      setAppliedCandidates(selectedEmails)

      // STEP 3: Fetch spot candidate statuses
      const fetchSpotCandidateStatuses = async (spotJdID) => {
        let statusList = [];
        let nextToken = null;

        try {
          do {
            const response = await API.graphql(
              graphqlOperation(listSpotCandidateStatuses, {
                filter: { spotJdID: { eq: spotJdID } },
                nextToken,
              })
            );

            const items = response?.data?.listSpotCandidateStatuses?.items ?? [];
            statusList = [...statusList, ...items];

            nextToken = response?.data?.listSpotCandidateStatuses?.nextToken;
          } while (nextToken);

          setSpotCandidateStatuses(statusList);
          console.log("Spot Candidate Statuses State Set:", statusList);
        } catch (error) {
          console.error("Error fetching Spot Candidate Statuses:", error);
        }
      };

      await fetchSpotCandidateStatuses(gptActivatedFor.id);

      // STEP 4: Fetch evaluations
      const fetchAllEvaluations = async (emails) => {
        let evaluations = [];
        let nextToken = null;

        try {
          do {
            const response = await API.graphql(
              graphqlOperation(listInterviewEvaluations, {
                filter: {
                  or: emails.map(email => ({ candidateEmail: { eq: email } }))
                },
                nextToken
              })
            );

            const items = response?.data?.listInterviewEvaluations?.items || [];
            evaluations = [...evaluations, ...items];
            nextToken = response?.data?.listInterviewEvaluations?.nextToken;
          } while (nextToken);

          const groupedEvaluations = emails
            .map(email => ({
              email,
              evaluations: evaluations.filter(ev => ev.candidateEmail === email)
            }))
            .filter(entry => entry.evaluations.length > 0);

          console.log("Filtered Evaluations:", groupedEvaluations);
          setInterviewDoneCandidates(groupedEvaluations);
          return groupedEvaluations;
        } catch (error) {
          console.error("Error fetching evaluations:", error);
          return [];
        }
      };

      await fetchAllEvaluations(selectedEmails);
    })();
  }, []); // You asked for no dependencies; only runs once


  const candidateStats = spotCandidateStatuses.reduce(
    (acc, item) => {
      // const roundStatus = item.roundStatus?.toLowerCase().replace(/\s/g, '');
      const roundStatus = item.roundStatus
      const selected = item.selectionFlag;

      if (roundStatus === 'firstRound') {
        acc.firstRound += 1;
      } else if (roundStatus === 'secondRound') {
        acc.secondRound += 1;
      }

      if (selected === true) {
        acc.selected += 1;
      } else if (selected === false) {
        acc.notSelected += 1;
      }

      return acc;
    },
    {
      firstRound: 0,
      secondRound: 0,
      selected: 0,
      notSelected: 0,
    }
  );

  console.log("Candidate Stats Summary:", candidateStats);

  const totalCandidates = appliedCandidates.length;

  const respondedEmails = interviewDoneCandidates.map(c => c.email);
  const uniqueResponders = new Set(respondedEmails);

  const responseRate = appliedCandidates.length
    ? ((uniqueResponders.size / appliedCandidates.length) * 100).toFixed(1)
    : 0;

  const daysActive = gptActivatedFor?.createdAt
    ? Math.ceil((new Date() - new Date(gptActivatedFor.createdAt)) / (1000 * 60 * 60 * 24))
    : 0;


  console.log("Total Candidates:", totalCandidates);
  console.log("Response Rate:", responseRate + "%");
  console.log("Days Active:", daysActive)


  // Spot Data code end

  // Candidate status distribution data
  const candidateStatusData = {
    labels: ['Matched', 'Contacted', 'Responded', 'Interviewed', 'Offered', 'Hired'],
    datasets: [
      {
        label: 'Candidates',
        // data: [65, 40, 32, 18, 6, 3],
        data: [totalCandidates, totalCandidates, interviewDoneCandidates.length, interviewDoneCandidates.length, candidateStats.selected, candidateStats.selected],
        backgroundColor: [
          'rgba(102, 126, 234, 0.6)',
          'rgba(116, 106, 214, 0.6)',
          'rgba(126, 96, 194, 0.6)',
          'rgba(136, 86, 184, 0.6)',
          'rgba(146, 76, 174, 0.6)',
          'rgba(156, 66, 164, 0.6)',
        ],
        borderColor: [
          'rgba(102, 126, 234, 1)',
          'rgba(116, 106, 214, 1)',
          'rgba(126, 96, 194, 1)',
          'rgba(136, 86, 184, 1)',
          'rgba(146, 76, 174, 1)',
          'rgba(156, 66, 164, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  // Skill match distribution data
  const skillMatchData = {
    labels: ['90-100%', '80-89%', '70-79%', '60-69%', 'Below 60%'],
    datasets: [
      {
        label: 'Candidates',
        data: [12, 18, 25, 15, 5],
        backgroundColor: [
          'rgba(102, 126, 234, 0.6)',
          'rgba(116, 106, 214, 0.6)',
          'rgba(126, 96, 194, 0.6)',
          'rgba(136, 86, 184, 0.6)',
          'rgba(146, 76, 174, 0.6)',
        ],
        borderColor: [
          'rgba(102, 126, 234, 1)',
          'rgba(116, 106, 214, 1)',
          'rgba(126, 96, 194, 1)',
          'rgba(136, 86, 184, 1)',
          'rgba(146, 76, 174, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  // Weekly application data
  const weeklyApplicationData = {
    labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
    datasets: [
      {
        label: 'Applications',
        data: [25, 42, 37, 30],
        backgroundColor: 'rgba(102, 126, 234, 0.6)',
        borderColor: 'rgba(102, 126, 234, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Response rate data
  const responseRateData = {
    labels: ['Responded', 'No Response'],
    datasets: [
      {
        label: 'Candidates',
        data: [32, 33],
        backgroundColor: [
          'rgba(102, 126, 234, 0.6)',
          'rgba(136, 86, 184, 0.6)',
        ],
        borderColor: [
          'rgba(102, 126, 234, 1)',
          'rgba(136, 86, 184, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  // Add new chart data

  // 1. Funnel Analysis Data
  const funnelData = {
    labels: ['Applied', 'Screened', 'Interviewed', 'Offered', 'Hired'],
    datasets: [
      {
        label: 'Candidates',
        // data: [120, 75, 40, 15, 8],
        data: [totalCandidates, interviewDoneCandidates.length, candidateStats.secondRound, candidateStats.selected, candidateStats.selected],
        backgroundColor: 'rgba(102, 126, 234, 0.6)',
        borderColor: 'rgba(102, 126, 234, 1)',
        borderWidth: 1,
      },
    ],
  };

  // 2. Source Effectiveness Data
  const sourceData = {
    labels: ['Job Boards', 'Referrals', 'Company Website', 'LinkedIn', 'Recruiters', 'Other'],
    datasets: [
      {
        label: 'Candidates by Source',
        data: [35, 25, 18, 12, 8, 2],
        backgroundColor: [
          'rgba(102, 126, 234, 0.6)',
          'rgba(116, 106, 214, 0.6)',
          'rgba(126, 96, 194, 0.6)',
          'rgba(136, 86, 184, 0.6)',
          'rgba(146, 76, 174, 0.6)',
          'rgba(156, 66, 164, 0.6)',
        ],
        borderColor: [
          'rgba(102, 126, 234, 1)',
          'rgba(116, 106, 214, 1)',
          'rgba(126, 96, 194, 1)',
          'rgba(136, 86, 184, 1)',
          'rgba(146, 76, 174, 1)',
          'rgba(156, 66, 164, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  // 3. Time-to-Hire Metrics Data
  const timeToHireData = {
    labels: ['Screening', 'First Interview', 'Technical Assessment', 'Final Interview', 'Offer', 'Onboarding'],
    datasets: [
      {
        label: 'Average Days',
        data: [3, 5, 7, 4, 3, 10],
        backgroundColor: 'rgba(102, 126, 234, 0.6)',
        borderColor: 'rgba(102, 126, 234, 1)',
        borderWidth: 1,
        borderRadius: 8,
      },
    ],
  };

  // 4. Quality of Hire Data (Scatter Plot)
  const qualityOfHireData = {
    datasets: [
      {
        label: 'Screening Score vs. Performance Rating',
        data: [
          { x: 85, y: 92 },
          { x: 78, y: 80 },
          { x: 92, y: 95 },
          { x: 65, y: 68 },
          { x: 72, y: 75 },
          { x: 88, y: 91 },
          { x: 76, y: 70 },
          { x: 82, y: 88 },
        ],
        backgroundColor: 'rgba(102, 126, 234, 0.6)',
        borderColor: 'rgba(102, 126, 234, 1)',
        borderWidth: 1,
        pointRadius: 6,
        pointHoverRadius: 8,
      },
    ],
  };

  // 5. Job-Specific Analysis Data (Stacked Bar)
  const jobSpecificData = {
    labels: ['Frontend Dev', 'Backend Dev', 'DevOps', 'UI/UX', 'QA Engineer'],
    datasets: [
      {
        label: 'Applied',
        data: [45, 52, 38, 30, 25],
        backgroundColor: 'rgba(102, 126, 234, 0.6)',
        borderColor: 'rgba(102, 126, 234, 1)',
        borderWidth: 1,
      },
      {
        label: 'Interviewed',
        data: [22, 30, 18, 15, 12],
        backgroundColor: 'rgba(126, 96, 194, 0.6)',
        borderColor: 'rgba(126, 96, 194, 1)',
        borderWidth: 1,
      },
      {
        label: 'Hired',
        data: [5, 8, 3, 4, 2],
        backgroundColor: 'rgba(156, 66, 164, 0.6)',
        borderColor: 'rgba(156, 66, 164, 1)',
        borderWidth: 1,
      },
    ],
  };

  // 6. Diversity & Inclusion Metrics
  const diversityData = {
    labels: ['Male', 'Female', 'Non-binary', 'Prefer not to say'],
    datasets: [
      {
        label: 'Gender Distribution',
        data: [42, 35, 3, 20],
        backgroundColor: [
          'rgba(102, 126, 234, 0.6)',
          'rgba(126, 96, 194, 0.6)',
          'rgba(156, 66, 164, 0.6)',
          'rgba(136, 86, 184, 0.6)',
        ],
        borderColor: [
          'rgba(102, 126, 234, 1)',
          'rgba(126, 96, 194, 1)',
          'rgba(156, 66, 164, 1)',
          'rgba(136, 86, 184, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  // 7. Candidate Feedback Sentiment
  const sentimentData = {
    labels: ['Very Positive', 'Positive', 'Neutral', 'Negative', 'Very Negative'],
    datasets: [
      {
        label: 'Candidate Feedback',
        data: [25, 40, 20, 10, 5],
        backgroundColor: [
          'rgba(72, 187, 120, 0.6)', // green
          'rgba(154, 230, 180, 0.6)', // light green
          'rgba(226, 232, 240, 0.6)', // gray
          'rgba(254, 178, 178, 0.6)', // light red
          'rgba(245, 101, 101, 0.6)', // red
        ],
        borderColor: [
          'rgba(72, 187, 120, 1)',
          'rgba(154, 230, 180, 1)',
          'rgba(226, 232, 240, 1)',
          'rgba(254, 178, 178, 1)',
          'rgba(245, 101, 101, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  // Bar chart options
  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Weekly Applications',
      },
    },
  };

  // Scatter plot options
  const scatterOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: 'rgba(255, 255, 255, 0.7)'
        }
      },
      title: {
        display: true,
        text: 'Screening Score vs. Performance',
        color: 'rgba(255, 255, 255, 0.9)'
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `Screening: ${context.parsed.x}%, Performance: ${context.parsed.y}%`;
          }
        }
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Screening Score (%)',
          color: 'rgba(255, 255, 255, 0.7)'
        },
        min: 60,
        max: 100,
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        },
        ticks: {
          color: 'rgba(255, 255, 255, 0.7)'
        }
      },
      y: {
        title: {
          display: true,
          text: 'Performance Rating (%)',
          color: 'rgba(255, 255, 255, 0.7)'
        },
        min: 60,
        max: 100,
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        },
        ticks: {
          color: 'rgba(255, 255, 255, 0.7)'
        }
      }
    }
  };

  // Bar chart options for stacked
  const stackedBarOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: 'rgba(255, 255, 255, 0.7)'
        }
      },
      title: {
        display: true,
        text: 'Recruitment Funnel by Role',
        color: 'rgba(255, 255, 255, 0.9)'
      }
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        },
        ticks: {
          color: 'rgba(255, 255, 255, 0.7)'
        }
      },
      y: {
        stacked: true,
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        },
        ticks: {
          color: 'rgba(255, 255, 255, 0.7)'
        }
      }
    }
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  return (
    // <div className="relative mt-[120px]">
    <div className="h-[70vh] overflow-y-auto overflow-x-hidden ">
      <div className="container mx-auto px-4 py-8 bg-gradient-to-br from-[#1e3a8a] via-[#3b82f6] to-[#885bb8] min-h-screen backdrop-blur-sm shadow-2xl">
        {/* Dashboard Header */}
        <div className=" bg-opacity-10 p-6 rounded-xl border border-white border-opacity-20 backdrop-filter backdrop-blur-sm shadow-xl mb-8">
          <h2 className="text-3xl font-bold text-white">{selectedjdname || 'Selected Job Description'}</h2>
          <p className="text-blue-100 mt-2">Analytics Dashboard</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* KPI Cards Row */}
          <div className=" bg-opacity-5 p-6 rounded-xl border border-white border-opacity-20 shadow-2xl backdrop-filter backdrop-blur-sm transform transition-all duration-300 hover:scale-[1.02] hover:bg-opacity-10">
            <h3 className="text-xl font-semibold mb-4 text-white">Key Metrics</h3>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-gradient-to-br from-[#2563eb] to-[#4f46e5] p-4 rounded-lg text-center shadow-lg transform transition-all duration-300 hover:shadow-xl hover:translate-y-[-2px]">
                <p className="text-sm text-blue-100">Total Candidates</p>
                <p className="text-3xl font-bold text-white">{totalCandidates ? (totalCandidates) : (0)}</p>
              </div>
              <div className="bg-gradient-to-br from-[#2563eb] to-[#4f46e5] p-4 rounded-lg text-center shadow-lg transform transition-all duration-300 hover:shadow-xl hover:translate-y-[-2px]">
                <p className="text-sm text-blue-100">Average Match</p>
                <p className="text-3xl font-bold text-white">78%</p>
              </div>
              <div className="bg-gradient-to-br from-[#2563eb] to-[#4f46e5] p-4 rounded-lg text-center shadow-lg transform transition-all duration-300 hover:shadow-xl hover:translate-y-[-2px]">
                <p className="text-sm text-blue-100">Response Rate</p>
                <p className="text-3xl font-bold text-white">{responseRate ? (`${responseRate}%`) : (0)}</p>
              </div>
              <div className="bg-gradient-to-br from-[#2563eb] to-[#4f46e5] p-4 rounded-lg text-center shadow-lg transform transition-all duration-300 hover:shadow-xl hover:translate-y-[-2px]">
                <p className="text-sm text-blue-100">Days Active</p>
                <p className="text-3xl font-bold text-white">{daysActive ? (daysActive) : (0)}</p>
              </div>
            </div>
          </div>

          {/* Candidate Status Distribution */}
          <div className=" bg-opacity-5 p-6 rounded-xl border border-white border-opacity-20 shadow-2xl backdrop-filter backdrop-blur-sm transform transition-all duration-300 hover:scale-[1.02] hover:bg-opacity-10">
            <h3 className="text-xl font-semibold mb-4 text-white">Candidate Pipeline</h3>
            <div className="h-72">
              <Bar
                data={{
                  ...candidateStatusData,
                  datasets: [{
                    ...candidateStatusData.datasets[0],
                    borderWidth: 2,
                    borderRadius: 8,
                    hoverOffset: 6
                  }]
                }}
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: { display: false },
                    title: { display: false }
                  },
                  scales: {
                    y: {
                      beginAtZero: true,
                      grid: {
                        color: 'rgba(255, 255, 255, 0.1)'
                      },
                      ticks: {
                        color: 'rgba(255, 255, 255, 0.7)'
                      }
                    },
                    x: {
                      grid: {
                        color: 'rgba(255, 255, 255, 0.1)'
                      },
                      ticks: {
                        color: 'rgba(255, 255, 255, 0.7)'
                      }
                    }
                  }
                }}
              />
            </div>
          </div>

          {/* Similar enhancements for other chart components */}
        </div>

        {/* Add new advanced analytics section */}
        <div className="mt-8">
          <h2 className="text-2xl font-bold text-white mb-6">Advanced Recruitment Analytics</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Funnel Analysis */}
            <div className=" bg-opacity-5 p-6 rounded-xl border border-white border-opacity-20 shadow-2xl backdrop-filter backdrop-blur-sm transform transition-all duration-300 hover:scale-[1.02] hover:bg-opacity-10">
              <h3 className="text-xl font-semibold mb-4 text-white">Recruitment Funnel Analysis</h3>
              <div className="h-72">
                <Bar
                  data={{
                    ...funnelData,
                    datasets: [{
                      ...funnelData.datasets[0],
                      borderRadius: 8,
                    }]
                  }}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    indexAxis: 'y',
                    plugins: {
                      legend: { display: false },
                      title: { display: false }
                    },
                    scales: {
                      x: {
                        grid: { color: 'rgba(255, 255, 255, 0.1)' },
                        ticks: { color: 'rgba(255, 255, 255, 0.7)' }
                      },
                      y: {
                        grid: { color: 'rgba(255, 255, 255, 0.1)' },
                        ticks: { color: 'rgba(255, 255, 255, 0.7)' }
                      }
                    }
                  }}
                />
              </div>
            </div>

            {/* Source Effectiveness */}
            <div className=" bg-opacity-5 p-6 rounded-xl border border-white border-opacity-20 shadow-2xl backdrop-filter backdrop-blur-sm transform transition-all duration-300 hover:scale-[1.02] hover:bg-opacity-10">
              <h3 className="text-xl font-semibold mb-4 text-white">Candidate Source Effectiveness</h3>
              <div className="h-72 flex justify-center items-center">
                <Doughnut
                  data={sourceData}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        position: 'right',
                        labels: { color: 'rgba(255, 255, 255, 0.7)' }
                      }
                    },
                    cutout: '60%',
                    radius: '90%',
                    animation: {
                      animateScale: true,
                      animateRotate: true
                    }
                  }}
                />
              </div>
            </div>

            {/* Time-to-Hire Metrics */}
            <div className="bg-opacity-5 p-6 rounded-xl border border-white border-opacity-20 shadow-2xl backdrop-filter backdrop-blur-sm transform transition-all duration-300 hover:scale-[1.02] hover:bg-opacity-10">
              <h3 className="text-xl font-semibold mb-4 text-white">Time-to-Hire Metrics</h3>
              <div className="h-72">
                <Bar
                  data={timeToHireData}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: { display: false },
                      tooltip: {
                        callbacks: {
                          label: function (context) {
                            return `${context.parsed.y} days`;
                          }
                        }
                      }
                    },
                    scales: {
                      y: {
                        title: {
                          display: true,
                          text: 'Days',
                          color: 'rgba(255, 255, 255, 0.7)'
                        },
                        grid: { color: 'rgba(255, 255, 255, 0.1)' },
                        ticks: { color: 'rgba(255, 255, 255, 0.7)' }
                      },
                      x: {
                        grid: { color: 'rgba(255, 255, 255, 0.1)' },
                        ticks: {
                          color: 'rgba(255, 255, 255, 0.7)',
                          maxRotation: 45,
                          minRotation: 45
                        }
                      }
                    }
                  }}
                />
              </div>
            </div>

            {/* Quality of Hire */}
            <div className="bg-opacity-5 p-6 rounded-xl border border-white border-opacity-20 shadow-2xl backdrop-filter backdrop-blur-sm transform transition-all duration-300 hover:scale-[1.02] hover:bg-opacity-10">
              <h3 className="text-xl font-semibold mb-4 text-white">Quality of Hire Analysis</h3>
              <div className="h-72">
                <Scatter
                  data={qualityOfHireData}
                  options={scatterOptions}
                />
              </div>
            </div>

            {/* Job-Specific Analysis */}
            <div className="bg-opacity-5 p-6 rounded-xl border border-white border-opacity-20 shadow-2xl backdrop-filter backdrop-blur-sm transform transition-all duration-300 hover:scale-[1.02] hover:bg-opacity-10">
              <h3 className="text-xl font-semibold mb-4 text-white">Job-Specific Recruitment Metrics</h3>
              <div className="h-72">
                <Bar
                  data={jobSpecificData}
                  options={stackedBarOptions}
                />
              </div>
            </div>

            {/* Diversity & Inclusion Metrics */}
            <div className="bg-opacity-5 p-6 rounded-xl border border-white border-opacity-20 shadow-2xl backdrop-filter backdrop-blur-sm transform transition-all duration-300 hover:scale-[1.02] hover:bg-opacity-10">
              <h3 className="text-xl font-semibold mb-4 text-white">Diversity & Inclusion Metrics</h3>
              <div className="h-72 flex justify-center items-center">
                <Pie
                  data={diversityData}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        position: 'right',
                        labels: { color: 'rgba(255, 255, 255, 0.7)' }
                      }
                    },
                    animation: {
                      animateScale: true,
                      animateRotate: true
                    }
                  }}
                />
              </div>
            </div>

            {/* Candidate Feedback & Sentiment */}
            <div className="bg-opacity-5 p-6 rounded-xl border border-white border-opacity-20 shadow-2xl backdrop-filter backdrop-blur-sm transform transition-all duration-300 hover:scale-[1.02] hover:bg-opacity-10">
              <h3 className="text-xl font-semibold mb-4 text-white">Candidate Feedback Sentiment</h3>
              <div className="h-72">
                <Bar
                  data={sentimentData}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: { display: false },
                    },
                    scales: {
                      y: {
                        grid: { color: 'rgba(255, 255, 255, 0.1)' },
                        ticks: { color: 'rgba(255, 255, 255, 0.7)' }
                      },
                      x: {
                        grid: { color: 'rgba(255, 255, 255, 0.1)' },
                        ticks: { color: 'rgba(255, 255, 255, 0.7)' }
                      }
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JDSpecificDashboard;
